import { render } from "./CourseWrapper.vue?vue&type=template&id=5f6f061c"
import script from "./CourseWrapper.vue?vue&type=script&lang=js"
export * from "./CourseWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__